/**
 * Shared button class strings.
 *
 * `PRIMARY_BTN` was previously declared identically in three admin components
 * and inlined verbatim ~29 more times, so the brand gradient drifted whenever
 * one copy was touched. Import this instead of re-typing the gradient.
 */

/** Primary call-to-action — the orange brand gradient. */
export const PRIMARY_BTN =
  'bg-gradient-to-br from-orange-500 to-orange-600 hover:from-orange-400 hover:to-orange-500 text-white shadow-lg shadow-orange-500/20'

/** Confirm/approve action in an approve-reject pair. */
export const APPROVE_BTN =
  'bg-gradient-to-br from-emerald-500 to-emerald-600 hover:from-emerald-400 hover:to-emerald-500 text-white shadow-lg shadow-emerald-500/20'

/** Destructive/reject action in an approve-reject pair. */
export const REJECT_BTN =
  'bg-gradient-to-br from-rose-500 to-rose-600 hover:from-rose-400 hover:to-rose-500 text-white shadow-lg shadow-rose-500/20'
